<template>
  <generic-container
    icon="key"
    :show_plus="true"
    :title="$t('access management')"
    class="ui basic segment"
    @add="add"
  >
    <div class="ui info message" style="display: block">
      <div class="header">{{ $t("hints") }}</div>
      <ul class="list">
        <li
          v-html="$t('the key is to verify incoming tokens and should match')"
        ></li>
      </ul>
    </div>
    <div class="ui form">
      <div class="two fields">
        <div class="field">
          <label for>{{ $t("key") }}</label>
          <input type="text" name="key" v-model="key" />
        </div>
        <div class="field">
          <label for>{{ $t("token name") }}</label>
          <input type="text" name="name" v-model="name" />
        </div>
        <!-- <div class="field">
          <label for>{{ $t("validity time") }}</label>
          <input type="text" name="name" v-model="validity_time" />
        </div> -->
        <!-- <div class="field">
          <label for>{{ $t("algorithm") }}</label>
          <div class="ui selection dropdown" ref="algorithm_dropdown">
            <input type="hidden" name="algorithm" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div> -->
      </div>
      <h3 class="ui dividing header">{{ $t("tokens") }}</h3>
      <div class="ui relaxed divided list">
        <div class="item" v-for="(token, index) in tokens" :key="index">
          <i class="large key middle aligned icon"></i>
          <div class="content">
            <div class="ui right floated mini basic buttons">
              <div class="ui icon labeled button" @click="copy(token.token)">
                <i class="blue copy icon"></i>
                {{ $t("copy") }}
              </div>
              <div class="ui icon labeled button" @click="remove(index)">
                <i class="red trash icon"></i>
                {{ $t("delete") }}
              </div>
            </div>
            <a class="header"
              >{{ token.name }}
              <small>
                |
                {{
                  token.create_date
                    | formatDate(enterprise_setup.detailed_date_format)
                }}</small
              >
            </a>
            <div class="description">
              {{ $t("validity time") }}
              <strong>{{ token.validity_time }}</strong>
              <small>
                | {{ $t("key") }} <i>{{ token.key }}</i>
              </small>
            </div>
            <div class="extra">
              {{ $t("algorithm") }}
              <strong>{{ token.algorithm }}</strong>
            </div>
            <div class="extra">
              {{ $t("token") }}
              <strong>{{ token.token | truncate(60) }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{users}}</pre> -->
    <jwt-modal
      v-if="show_jwt_modal"
      ref="jwt_modal"
      @destroy="show_jwt_modal = false"
      @created="created"
    />
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { isEmpty } from "lodash";
import {
  // error_toast,
  // local_api,
  enterprise_setup,
  success_toast,
} from "@/utils";
// import moment from "moment";
import filters from "@/filters";
import copy from "copy-to-clipboard";
import JwtModal from "@/modules/api_manager/jwt_modal/Index.vue";

export default {
  name: "JwtAuthentication",
  filters: filters,
  components: { GenericContainer, JwtModal },
  props: {
    endpoint_in: Object,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      key: "",
      name: "",
      // validity_time: "7d",
      algorithm: "none",
      tokens: [],
      show_jwt_modal: false,
    };
  },
  methods: {
    getData() {
      return {
        key: this.key,
        name: this.name,
        validity_time: this.validity_time,
        algorithm: this.algorithm,
        tokens: this.tokens,
      };
    },
    add() {
      let vm = this;
      vm.show_jwt_modal = true;
      setTimeout(() => {
        vm.$refs.jwt_modal.set_key_token({ key: vm.key, name: vm.name });
      }, 200);

      // vm.$alertify.prompt(this.$t("enter token name"), "", function(
      //   element,
      //   value,
      // ) {
      //   local_api(vm, "post", "/api_manager/do-create-jwt-token", {
      //     n: value,
      //     k: vm.key,
      //     a: vm.algorithm,
      //     t: vm.validity_time,
      //   })
      //     .then((token) => {
      //       vm.tokens.push({
      //         name: value,
      //         key: vm.key,
      //         token: token,
      //         algorithm: vm.algorithm,
      //         create_date: moment(),
      //         validity_time: vm.validity_time,
      //       });
      //     })
      //     .catch((err) => {
      //       error_toast(err);
      //     });
      // });
    },
    copy(token) {
      copy(token);
      success_toast(this.$t("token copied to clipboard"));
    },
    remove(index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove token?"), function() {
        vm.tokens.splice(index, 1);
      });
    },
    created(token) {
      this.tokens.push(token);
    },
  },
  mounted() {
    let vm = this;
    if (!isEmpty(this.endpoint_in)) {
      this.key = this.endpoint_in.setup.security.jwt_key || "modul";
      this.name = this.endpoint_in.setup.security.jwt_token_name || "my-t";
      this.tokens = this.endpoint_in.setup.security.tokens || [];
      this.algorithm = this.endpoint_in.setup.security.jwt_algorithm || "none";
      if (vm.algorithm) {
        setTimeout(() => {
          window
            .jQuery(vm.$refs.algorithm_dropdown)
            .dropdown("set selected", vm.algorithm);
        }, 1000);
      }
    }

    // let vls = [
    //   { name: vm.$t("hmac using sha-256 hash algorithm"), value: "HS256" },
    //   { name: vm.$t("hmac using sha-384 hash algorithm"), value: "HS384" },
    //   { name: vm.$t("hmac using sha-512 hash algorithm"), value: "HS512" },
    //   {
    //     name: vm.$t("rsassa-pkcs1-v1_5 using sha-256 hash algorithm"),
    //     value: "RS256",
    //   },
    //   {
    //     name: vm.$t("rsassa-pkcs1-v1_5 using sha-384 hash algorithm"),
    //     value: "RS384",
    //   },
    //   {
    //     name: vm.$t("rsassa-pkcs1-v1_5 using sha-512 hash algorithm"),
    //     value: "RS512",
    //   },
    //   {
    //     name: vm.$t(
    //       "rsassa-pss using sha-256 hash algorithm (only node ^6.12.0 or >=8.0.0)",
    //     ),
    //     value: "PS256",
    //   },
    //   {
    //     name: vm.$t(
    //       "rsassa-pss using sha-384 hash algorithm (only node ^6.12.0 or >=8.0.0)",
    //     ),
    //     value: "PS384",
    //   },
    //   {
    //     name: vm.$t(
    //       "rsassa-pss using sha-512 hash algorithm (only node ^6.12.0 or >=8.0.0)",
    //     ),
    //     value: "PS512",
    //   },
    //   {
    //     name: vm.$t("ecdsa using p-256 curve and sha-256 hash algorithm"),
    //     value: "ES256",
    //   },
    //   {
    //     name: vm.$t("ecdsa using p-384 curve and sha-384 hash algorithm"),
    //     value: "ES384",
    //   },
    //   {
    //     name: vm.$t("ecdsa using p-521 curve and sha-512 hash algorithm"),
    //     value: "ES512",
    //   },
    //   {
    //     name: vm.$t("none"),
    //     value: "none",
    //   },
    // ];
    // window
    //   .jQuery(vm.$refs.algorithm_dropdown)
    //   .dropdown("setup menu", { values: vls })
    //   .dropdown({
    //     onChange(value) {
    //       vm.algorithm = value;
    //     },
    //   });
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>
